import PortfolioDialog from './PortfolioDialog';
import ServiceDialog from './ServiceDialog';
import TestimonialDialog from './TestimonialDialog';
import PurchaseDomainDialog from './PurchaseDomainDialog';

export {
  PortfolioDialog,
  ServiceDialog,
  TestimonialDialog,
  PurchaseDomainDialog
}



// WEBPACK FOOTER //
// ./src/components/admin/Website/Dialogs/index.js